import { createSelector } from '@reduxjs/toolkit'

import { selectDownload } from './selectDownload'

// Calculate download speed (bytes per second)
export const selectDownloadSpeed = createSelector(selectDownload, (download) => {
  if (!download.startedAt || download.loadedBytes === 0) return null

  const elapsedSeconds = (Date.now() - download.startedAt) / 1000
  if (elapsedSeconds === 0) return null

  return download.loadedBytes / elapsedSeconds // bytes per second
})
